import { FOOTER_HEIGHT, LARGE_TOP_BAR_HEIGHT, SMALL_TOP_BAR_HEIGHT } from 'constants/styled.contants';
import styled, { css } from 'styled-components';

export const ProfileWrapper = styled.div<{ isPaidFee?: boolean; isProfileSizeSmall?: boolean; hasDrawer?: boolean }>`
  width: 100%;
  height: 100vh;
  background-color: ${({ theme }) => theme.color.background.neutral.default};
  position: relative;
  z-index: 11;
  overflow-y: auto;
  overflow-x: hidden;
  scroll-behavior: smooth;
  ${({ hasDrawer, theme }) =>
    hasDrawer &&
    css`
      padding-bottom: ${theme.spacing.km14};
    `}

  ${({ hasDrawer, theme }) =>
    !hasDrawer &&
    css`
      padding-bottom: ${SMALL_TOP_BAR_HEIGHT};

      @media (max-width: 576px) {
        padding-bottom: calc(${FOOTER_HEIGHT} + ${LARGE_TOP_BAR_HEIGHT});
      }

      @media (min-width: 576px) and (max-width: ${theme.breakpoint.lg.maxWidth}) {
        padding-bottom: calc(${LARGE_TOP_BAR_HEIGHT});
      }
    `}


  ${({ isPaidFee, isProfileSizeSmall }) =>
    isPaidFee &&
    css`
      padding-bottom: ${isProfileSizeSmall ? '160px' : '96px'};
    `}
`;
